export default __webpack_public_path__ + "static/media/BNB.12f6ca37.png";